<template>
  <q-btn
    v-if="navConfig"
    flat
    no-caps
    dense
    color="primary"
    class="header-section-nav-btn text-16"
    :icon="navConfig.icon"
    :label="navConfig.label"
    :to="{ name: navConfig.to }"
  >
  </q-btn>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { ROUTES } from 'src/services/consts/routes.const'

const route = useRoute()

const isCompaniesList = computed(() => route.name === ROUTES.COMPANY && !route.params.id)
const isCreationRequestsList = computed(() => route.name === ROUTES.CREATION_REQUESTS)

const navConfig = computed(() => {
  if (isCompaniesList.value) {
    return {
      label: 'Go to creation requests',
      to: ROUTES.CREATION_REQUESTS,
      icon: 'rate_review',
    }
  }
  if (isCreationRequestsList.value) {
    return {
      label: 'Back to companies',
      to: ROUTES.COMPANY,
      icon: 'arrow_back',
    }
  }
  return null
})
</script>

<style lang="scss">
.header-section-nav-btn {
  min-width: 0;
  max-width: 280px;

  .q-btn__content {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .block {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
